import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'E-mailadres bevestigen',
  [OnboardingStep.StoreDetails]: 'Winkelgegevens',
  [OnboardingStep.BusinessInfo]: 'Bedrijfsgegevens',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Voeg uw winkelgegevens toe',
  [OnboardingStep.PersonalInfo]: 'Voeg uw persoonlijke gegevens toe',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Persoonlijke gegevens van eigenaar',
  owner_personal_info_gmbh: 'Persoonlijke gegevens van eigenaar / directeur',
  [OnboardingStep.ShippingInfo]: 'Voeg uw bezorggegevens toe',
  [OnboardingStep.BankInfo]: 'Bankgegevens toevoegen voor uitbetalingen',
  [OnboardingStep.TaxInfo]: 'Is uw bedrijf btw-plichtig?',
  [OnboardingStep.BusinessDocs]: 'Bewijs van bedrijfsdocument',
  [OnboardingStep.PersonalDocs]: 'Identiteitsbewijs',
  [OnboardingStep.InfoSubmission]: 'Betaald worden',
  confirm_info_gateway: 'Betaald worden – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Betalingsgegevens',
  [OnboardingStep.Subscription]: 'Abonnement',
  [OnboardingStep.MobileApp]: 'Mobiele app',
  [OnboardingStep.DeliveryStructure]: 'Bezorgstructuur',
  [OnboardingStep.Contract]: 'Contract',
  [OnboardingStep.ContractPayment]: 'Contractbetaling',
  [OnboardingStep.Documents]: 'Documenten uploaden',
  [OnboardingStep.PromoCode]: 'Promotiecode',
};
